module.exports = __webpack_public_path__ + "img/bgg.39e6ff86.png";